import 'reflect-metadata';
export function ConstructorName(name) {
  return Reflect.metadata('constructorName', name);
}
